/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function JoystickIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "joystick", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("circle", { cx: 12.5, cy: 7.5, r: 3, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M11.5 10.5V15.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M13.5 10.5V15.5", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M9.5 17V15.5H15.5V17", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M5.5 17.5H19.5V20.5H5.5V17.5Z", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(JoystickIcon);
export default ForwardRef;
//# sourceMappingURL=joystickIcon.js.map